export interface Lesson {
  nendo: number
  lesson_code: string
  lesson_name: string
  subject_code: string
  subject_name: string
  tantou_login_id: string
  user_name: string
}

export class LessonClass {
  id: number
  lesson_class_no: string
  content: string
  start_datetime_at: Date
  end_datetime_at: Date
  is_published: boolean
  is_print_view_point: boolean
  is_print_view_point_cache: boolean
  is_print_part1: boolean
  is_print_part1_cache: boolean
  passing_score: string
  score_positions_completed: boolean

  get requiresFollowUpSettingPart1(): boolean{
    return this.is_print_part1 != this.is_print_part1_cache && this.is_print_part1;
  }

  get requiresFollowUpSettingViewPoint(): boolean{
    return this.is_print_view_point != this.is_print_view_point_cache && this.is_print_view_point;
  }

  get requiresFollowUpSetting(): boolean {
    return this.score_positions_completed && (this.requiresFollowUpSettingPart1 || this.requiresFollowUpSettingViewPoint);
  }

  constructor(lessonClass: any){
    this.id = lessonClass.id;
    this.lesson_class_no = lessonClass.lesson_class_no;
    this.content = lessonClass.content;
    this.start_datetime_at = lessonClass.start_datetime_at;
    this.end_datetime_at = lessonClass.end_datetime_at;
    this.is_published = lessonClass.is_published;
    this.is_print_view_point = lessonClass.is_print_view_point;
    this.is_print_view_point_cache = lessonClass.is_print_view_point;
    this.is_print_part1 = lessonClass.is_print_part1;
    this.is_print_part1_cache = lessonClass.is_print_part1;
    this.passing_score = lessonClass.passing_score;
    this.score_positions_completed = lessonClass.score_positions_completed;
  }
}